import { Button, ButtonProps } from 'antd';

import './style.less';

const SaveButton: React.FC<ButtonProps> = ({ children, ...ButtonProps }) => (
  <Button type="primary" className="save-button" {...ButtonProps}>
    {children}
  </Button>
);

export default SaveButton;
